import React from 'react'
import { connect } from 'react-redux'

import { updatePurchaseOrderNumber } from './paymentMethodActionCreators'

import { Fade } from '../../../SharedComponents/componentAnimations'

const PurchaseOrderComponent = ({ poNumber, selected, onChange, label = 'Your Internal PO Number', placeholder = 'Optional' }) => (
  <Fade inProp={selected} >
    <div className='col-xs-12 form-group'>
      <label htmlFor='ponumber'>{label}</label>
      <input
        className="form-control"
        name='ponumber'
        id='ponumber'
        type='text'
        placeholder={placeholder}
        onChange={e => onChange(e)}
        value={poNumber}
      />
    </div>
  </Fade>
)

const mapStateToProps = (state, ownProps) => ({
  poNumber: state.entities.PaymentRecord.POValue || "",
  selected: state.entities.SelectedPaymentOptionId === state.constants.purchaseOrderPaymentId,
  ...ownProps
})

const mapDispatchToProps = dispatch => ({
  onChange: (e) => (e && e.target && dispatch(updatePurchaseOrderNumber(e.target.value)))
})

const PurchaseOrderComponentContainer = connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderComponent)

export default PurchaseOrderComponentContainer